<template>
    <div class="services-details-area d-flex align-items-center justify-content-center" style="min-height: 100vh;">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-12">
                    <div class="services-details-image text-center mb-4">
                        <img src="../../assets/images/services/facial-aesthetics/alternative-ways/aisthitikos-velonismos-main.webp" alt="image">
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('alternative_therapies_title') }}</h3></u>
                        <p>{{ $t('alternative_therapies_p') }}</p> 
                    </div>

                    <div class="services-details-content">
                        <u><h3>{{ $t('alternative_therapies_rejuvance_title') }}</h3></u>
                        <p>{{ $t('alternative_therapies_rejuvance_p') }}</p> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>




    export default {
        name: 'AlternativeTherapies',
           };
   
</script>
